import { forwardRef } from "react";
import styles from "./ArticleRelatedContentModule.module.scss";
import { gql } from "utils/urql";
import dynamic from "next/dynamic";
import {
  ArticleRelatedContentModuleFragment,
  ArticleRelatedContentType,
} from "types/api";
import { useArticleContext } from "utils/articleContext";

const ArticleRelatedContentCurated = dynamic(
  () => import("components/article/ArticleRelatedContentCurated")
);
const ArticleRelatedContentChannel = dynamic(
  () => import("components/article/ArticleRelatedContentChannel")
);
const ArticleRelatedContentMagazine = dynamic(
  () => import("components/article/ArticleRelatedContentMagazine")
);

const ArticleRelatedContentModule = forwardRef<
  HTMLDivElement,
  ArticleRelatedContentModuleFragment & { count: number }
>(function ArticleRelatedContentModule({ contentType, count }, ref) {
  const { articleId, primaryCategorySlug, previewParam } = useArticleContext();

  switch (contentType) {
    case ArticleRelatedContentType.Magazine:
      return (
        <div className={styles.root} ref={ref}>
          <ArticleRelatedContentMagazine
            id={articleId}
            preview={previewParam}
          />
        </div>
      );
    case ArticleRelatedContentType.Curated:
      return (
        <div className={styles.root} ref={ref}>
          <div className={styles.notchedModule}>
            <ArticleRelatedContentCurated
              id={articleId}
              preview={previewParam}
              count={count}
            />
          </div>
        </div>
      );
    case ArticleRelatedContentType.Channel:
      return (
        <div className={styles.root} ref={ref}>
          <div className={styles.notchedModule}>
            <ArticleRelatedContentChannel
              id={articleId}
              slug={primaryCategorySlug}
              count={count}
            />
          </div>
        </div>
      );
    case ArticleRelatedContentType.Editorialproject:
    case ArticleRelatedContentType.Category:
    default:
      // Any component in the article body must be an element
      // It's simpler to be consistent and have an empty element
      // than return null
      return <div ref={ref}></div>;
  }
});

export default ArticleRelatedContentModule;

ArticleRelatedContentModule.fragment = gql`
  fragment articleRelatedContentModule on ArticleRelatedContentModule {
    contentType
  }
`;
